import { TableProperties } from "PFApp/components/table_properties/table_properties";
import { useManageRolesStore, useManageRolesStoreActions } from "PFApp/stores/manage_roles";
import { TableColumn } from "PFCore/types";

export const ManageRolesTablePropertiesSidePanelContent = () => {
  const availableColumns = useManageRolesStore((state) => state.availableColumns);
  const selectedColumnNames = useManageRolesStore((state) => state.selectedColumns);
  const { setSelectedColumns } = useManageRolesStoreActions();

  const selectedColumns = selectedColumnNames
    .map((name) => availableColumns.find((column) => column.name === name))
    .filter((column): column is TableColumn => !!column);

  const handleColumnsChange = (columns: TableColumn[]) => setSelectedColumns(columns.map(({ name }) => name));

  return (
    <TableProperties
      availableColumns={availableColumns}
      selectedColumns={selectedColumns}
      onColumnsChange={handleColumnsChange}
    />
  );
};
